import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output
} from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'

import { appConstants } from '../../../../app.constants'
import { ResourceSlug } from '../../../../shared/enums/wordpress/wp-resource-slug.enum'
import { FlashMessageService } from '../../../../shared/services/flash-message.service'
import { NotificationService } from '../../services/notification.service'

@Component({
  selector: 'app-flag-modal',
  templateUrl: './flag-modal.component.html',
  styleUrls: ['./flag-modal.component.scss']
})
export class FlagModalComponent {
  @Input() resourceId: number
  @Input() resourceType: ResourceSlug

  @Output() modalClosed: EventEmitter<void> = new EventEmitter()

  isUserSubmitter = false
  ResourceType = ResourceSlug
  resourceName: string
  captchaKey = appConstants.RECAPTCHA_SITE_KEY

  form: FormGroup

  constructor(
    private formBuilder: FormBuilder,
    private flashMessageService: FlashMessageService,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      description: ['', Validators.required],
      email: ['', [Validators.email, Validators.required]],
      affiliation: ['', Validators.required],
      captcha: [null, [Validators.required]]
    })

    switch (this.resourceType) {
      case ResourceSlug.Tools:
        this.resourceName = 'tool'
        break
      case ResourceSlug.ToolUseCases:
        this.resourceName = 'tool use case'
        break
      case ResourceSlug.Metrics:
        this.resourceName = 'metric'
        break
      case ResourceSlug.MetricUseCases:
        this.resourceName = 'metric use case'
        break
    }
  }

  askForChange(formValue: {
    description: string
    email: string
    affiliation: string
  }) {
    this.notificationService
      .askForChange(this.resourceType, {
        description: formValue.description,
        email: formValue.email,
        affiliation: formValue.affiliation,
        linkToResource: window.location.href
      })
      .then(
        () => {
          this.flashMessageService.success(
            'The request has been sent to the OECD.AI secretariat and will be treated shortly. Thank you for your request.'
          )
          this.modalClosed.emit()
        },
        () => {
          this.flashMessageService.error(
            'An error occurred. Please try again later.'
          )
        }
      )
  }

  askForEditAccess() {
    return this.notificationService
      .askForEditAccess(this.resourceType, this.resourceId)
      .then(
        () => {
          this.flashMessageService.success(
            `An email with the modification link has been sent to the submitter of this ${this.resourceName}.`
          )
          this.modalClosed.emit()
        },
        () => {
          this.flashMessageService.error(
            'An error occurred. Please try again later.'
          )
        }
      )
  }

  onDescriptionChanged(wysiwygInputValue: string) {
    this.form.get('description').setValue(wysiwygInputValue)
  }

  @HostListener('document:click', ['$event.target'])
  onClick(target: any) {
    // We track clicks to close model if open and click outside
    if (target.className === 'modal-background') {
      this.modalClosed.emit()
    }
  }
}
